export class ManquementContenantEdition {
    static jsonMap = {
        format: { key: 'format', optional: true, default: '' },
        nombre: { key: 'nombre', optional: true, default: '' },
        volume: { key: 'volume', optional: true, default: '' }
    }

    format: string;
    nombre: string;
    volume: string;

}